import axios from '@/utils/api'

const actions = {
  async getDocumentoViewByKey ({ commit }, key) {
    return axios({
      url: `documento/file/${key}`,
      method: 'GET'
    })
  },
  async getDocumentoViewByPath ({ commit }, path) {
    return axios({
      url: 'documento/path',
      method: 'POST',
      data: { path }
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/documento.js